export default __webpack_public_path__ + "static/media/taylor.87ef0ffa.svg";